import { __awaiter, __generator } from "tslib";
export var isSsoTokenDto = function (creds) {
    var a = creds;
    return !!(a.params && a.params.id);
};
export var isApiCredentialsDto = function (creds) {
    var a = creds;
    return !!(a.keyId && a.secret);
};
var getApiToken = function (credentials, http, baseUrl) { return http.post(baseUrl + "/accounts/token", credentials); };
var getSsoToken = function (credentials, http, baseUrl) { return http.post(baseUrl + "/accounts/token/sso", credentials); };
export var getAccessToken = function (credentials, http, baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var obj, obj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isSsoTokenDto(credentials)) return [3 /*break*/, 2];
                return [4 /*yield*/, getSsoToken(credentials, http, baseUrl)];
            case 1:
                obj = _a.sent();
                return [2 /*return*/, obj.token];
            case 2:
                if (!isApiCredentialsDto(credentials)) return [3 /*break*/, 4];
                return [4 /*yield*/, getApiToken(credentials, http, baseUrl)];
            case 3:
                obj = _a.sent();
                return [2 /*return*/, obj.token];
            case 4: return [2 /*return*/, credentials];
        }
    });
}); };
//# sourceMappingURL=get-access-token.js.map